export default {
  responsiveMenuOpen({commit}, payload) {
    commit('SET_RESPONSIVE_MENU_OPEN', payload)
  }
}